import { render } from "./postPopup.vue?vue&type=template&id=4020a928"
import script from "./postPopup.vue?vue&type=script&lang=js"
export * from "./postPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__